import api from '@/api/axios';
import { PrimaryButton } from '@/components/Button';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { AnonymousStackParamList } from '@/navigations/AnonymousStack';
import { StackScreenProps } from '@react-navigation/stack';
import { useState } from 'react';
import { View } from 'react-native';
import { LoginLayout } from './Layout';
import { styles } from './ReactivateAccount.styles';

export function ReactivateAccount({
  route,
  navigation,
}: StackScreenProps<AnonymousStackParamList, 'ReactivateAccount'>) {
  const reactivationToken = route.params.reactivationToken;
  const [isRequested, setIsRequested] = useState(false);

  function handlePress() {
    if (isRequested) {
      return navigation.navigate('Login', {});
    }
    api
      .post(`/api/users/reactivation/${reactivationToken}`)
      .then(() => {
        setIsRequested(true);
      })
      .catch(() => {});
  }

  return (
    <LoginLayout>
      <View>
        {isRequested ? (
          <Text style={styles.headingLg}>Aktivierung wurde angefordert</Text>
        ) : (
          <Text style={styles.headingLg}>
            Ihr Benutzerkonto wurde deaktiviert
          </Text>
        )}

        {isRequested ? (
          <Text style={styles.bodyText}>
            Ihre Anfrage wurde gesendet. Unser Kundendienst wird sich sofort
            darum kümmern. Sie erhalten eine E–Mail, sobald Ihr Benutzerkonto
            wieder aktiviert ist.
          </Text>
        ) : (
          <Text style={styles.bodyText}>
            Unser Kundenservice kann Ihr Benutzerkonto wieder aktivieren. Sie
            können die Aktivierung telefonisch unter{' '}
            <TextLink href="tel:+49089248864440">
              +49 (0)89 24 886 4440
            </TextLink>{' '}
            anfordern oder direkt eine Anfrage an uns senden.
          </Text>
        )}

        <PrimaryButton
          label={'Benutzerkonto erneut aktivieren'}
          onPress={handlePress}
        />

        <Text
          style={styles.backLink}
          onPress={() => navigation.navigate('Login', {})}
        >
          Zurück zum Login
        </Text>
      </View>
    </LoginLayout>
  );
}
